module.exports = __webpack_public_path__ + "archivist_columbus.png?06b10e9d26aaf65da9235a7dd5b21953";


//////////////////
// WEBPACK FOOTER
// ./src/img/profili/archivist_columbus.png
// module id = 389
// module chunks = 0